export const CAMPAIGN_VALIDATE_LOADING = 'campaign/CAMPAIGN_VALIDATE_LOADING'
export const CAMPAIGN_VALIDATE_SUCCESS = 'campaign/CAMPAIGN_VALIDATE_SUCCESS'
export const CAMPAIGN_VALIDATE_FAIL = 'campaign/CAMPAIGN_VALIDATE_FAIL'

export const CAMPAIGN_CHECK_USAGE_LOADING = 'campaign/CAMPAIGN_CHECK_USAGE_LOADING'
export const CAMPAIGN_CHECK_USAGE_SUCCESS = 'campaign/CAMPAIGN_CHECK_USAGE_SUCCESS'
export const CAMPAIGN_CHECK_USAGE_FAIL = 'campaign/CAMPAIGN_CHECK_USAGE_FAIL'

export const CAMPAIGN_REGISTER_USAGE_LOADING = 'campaign/CAMPAIGN_REGISTER_USAGE_LOADING'
export const CAMPAIGN_REGISTER_USAGE_SUCCESS = 'campaign/CAMPAIGN_REGISTER_USAGE_SUCCESS'
export const CAMPAIGN_REGISTER_USAGE_FAIL = 'campaign/CAMPAIGN_REGISTER_USAGE_FAIL'

export const CAMPAIGN_RESET = 'campaign/CAMPAIGN_RESET'

const initialState = {
  token: null,
  campaignData: null,
  isValid: false,
  isLoading: false,
  errorMessage: null,
  hasUsedPromotion: false,
  usageCheckLoading: false,
  registerUsageLoading: false,
}

export const CampaignReducer = (state = initialState, action) => {
  switch (action.type) {
    case CAMPAIGN_VALIDATE_LOADING:
      return { ...state, isLoading: true, errorMessage: null }
    case CAMPAIGN_VALIDATE_SUCCESS:
      return {
        ...state,
        isLoading: false,
        token: action.payload.token,
        campaignData: action.payload.data,
        isValid: action.payload.data.active,
        errorMessage: null,
      }
    case CAMPAIGN_VALIDATE_FAIL:
      return {
        ...state,
        isLoading: false,
        isValid: false,
        errorMessage: action.payload.error,
      }
    case CAMPAIGN_CHECK_USAGE_LOADING:
      return { ...state, usageCheckLoading: true, errorMessage: null }
    case CAMPAIGN_CHECK_USAGE_SUCCESS:
      return {
        ...state,
        usageCheckLoading: false,
        hasUsedPromotion: action.payload.data.hasUsed,
        errorMessage: null,
      }
    case CAMPAIGN_CHECK_USAGE_FAIL:
      return {
        ...state,
        usageCheckLoading: false,
        errorMessage: action.payload.error,
      }
    case CAMPAIGN_REGISTER_USAGE_LOADING:
      return { ...state, registerUsageLoading: true, errorMessage: null }
    case CAMPAIGN_REGISTER_USAGE_SUCCESS:
      return {
        ...state,
        registerUsageLoading: false,
        errorMessage: null,
      }
    case CAMPAIGN_REGISTER_USAGE_FAIL:
      return {
        ...state,
        registerUsageLoading: false,
        errorMessage: action.payload.error,
      }
    case CAMPAIGN_RESET:
      return initialState
    default:
      return state
  }
}
